import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersistence from 'vuex-persist'

Vue.use(Vuex)

const vuexLocal = new VuexPersistence({
  key: 'vuex',
  storage: window.localStorage
})

export default new Vuex.Store({
  state: {
    count: 2,
    code: '',
    engine: ''
  },
  plugins: [vuexLocal.plugin],
  mutations: {
    increment (state) {
      state.count++
    },
    initConnection (state,payload) {
      state.code = payload.code
      state.engine = payload.engine
    }
  },
  getters: {
    code: state => {
      return state.code
    },
    engine: state => {
      return state.engine
    }
  },
  actions: {

  }
})
